import React from 'react';
import { Phone, Users, Target, Award, Clock, MessageCircle } from 'lucide-react';
import { aboutInfo, whatsappLink } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Hakkımızda</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            {aboutInfo.description}
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-8 rounded-2xl">
              <Target className="w-12 h-12 text-orange-600 mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h2>
              <p className="text-gray-700 leading-relaxed">
                İstanbul Kadıköy bölgesinde yaşayan sürücülere en hızlı, en güvenilir ve en kaliteli mobil yol yardım hizmetini sunmak. Müşterilerimizin yol kenarında geçirdikleri zamanı minimum seviyeye indirerek, güvenli bir şekilde yollarına devam etmelerini sağlamak.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl">
              <Award className="w-12 h-12 text-blue-600 mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h2>
              <p className="text-gray-700 leading-relaxed">
                İstanbul'un en güvenilir ve tercih edilen mobil yol yardım hizmeti olmak. Müşteri memnuniyetini ön planda tutarak, sektörün standartlarını yükseltmek ve her sürücünün güvenle yola çıkabileceği bir ekosistem oluşturmak.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Neden Bizi Tercih Etmelisiniz?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {aboutInfo.features.map((feature, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-lg">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-orange-600 to-red-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <Clock className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl font-bold mb-2">7/24</div>
              <div className="text-lg opacity-90">Hizmet</div>
            </div>
            <div>
              <Users className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl font-bold mb-2">1000+</div>
              <div className="text-lg opacity-90">Mutlu Müşteri</div>
            </div>
            <div>
              <Target className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl font-bold mb-2">20-30</div>
              <div className="text-lg opacity-90">Dakika Ulaşım</div>
            </div>
            <div>
              <Award className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl font-bold mb-2">%100</div>
              <div className="text-lg opacity-90">Müşteri Memnuniyeti</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Profesyonel Ekibimiz
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Deneyimli ve sertifikalı teknisyenlerimiz ile her zaman yanınızdayız
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-12 rounded-2xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-10 h-10 text-orange-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Deneyimli Ekip</h3>
                <p className="text-gray-600">
                  10+ yıl sektör tecrübesi olan uzman teknisyenler
                </p>
              </div>
              <div>
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-10 h-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Sertifikalı</h3>
                <p className="text-gray-600">
                  Tüm ekip üyelerimiz sertifikalı ve eğitimli
                </p>
              </div>
              <div>
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="w-10 h-10 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Müşteri Odaklı</h3>
                <p className="text-gray-600">
                  Müşteri memnuniyeti bizim en önemli hedefimiz
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Hemen Bizimle İletişime Geçin
          </h2>
          <p className="text-xl mb-8 text-gray-300">
            7/24 hizmetinizdeyiz. Yardıma ihtiyacınız olduğunda bizi arayın!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 bg-green-500 text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-green-600 transition-all transform hover:scale-105 shadow-2xl"
            >
              <MessageCircle className="w-7 h-7" />
              <span>WhatsApp</span>
            </a>
            <a
              href="tel:05534834264"
              className="inline-flex items-center space-x-3 bg-orange-600 text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-orange-700 transition-all transform hover:scale-105 shadow-2xl"
            >
              <Phone className="w-7 h-7" />
              <span>0553 483 42 64</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;